import DynamicBasicSelectField from './form/DynamicBasicSelectField'

class CardDynamicDropdownField extends DynamicBasicSelectField {
}
export default CardDynamicDropdownField




// WEBPACK FOOTER //
// ./src/components/CardDynamicDropdownField.js